import { IsoDate, IsoDateTime } from '../../../types/iso-date';

export function toIsoDateTime(date: Date): IsoDateTime {
  const svDate = new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);
  // svDate expected format: "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DD HH:mm:ss"
  const [datePart, timePart] = svDate.split(' ');

  const ms = date.getMilliseconds().toString().padStart(3, '0');
  return `${datePart}T${timePart}.${ms}` as IsoDateTime;
}
